import { GoogleAnalyticsDirective } from './googleAnalytics.directive';
import { GoogleAnalyticsSetupService } from './googleAnalyticsSetup.service';
import { GoogleAnalyticsTrackingService } from './googleAnalyticsTracking.service';

export const GoogleAnalyticsModule = angular
    .module('oo.googleAnalytics', [])
    .constant('GA_TRACKING_LABEL', {
        EVENT_CATEGORY: {
            LOGIN: {
                TEXT: 'Login',
                EVENT_ACTION: {
                    LOGIN_MODAL: {
                        TEXT: 'Login Modal'
                    },
                    LOGIN_SUCCESSFUL: {
                        TEXT: 'Login Successful'
                    },
                    LOGIN_ERROR: {
                        TEXT: 'Login Error'
                    }
                }
            },
            ACCOUNT_CREATION: {
                TEXT: 'Account Creation',
                EVENT_ACTION: {
                    CREATE_ACCOUNT_SUCCESSFUL: {
                        TEXT: 'Create Account Successful'
                    },
                    CREATE_ACCOUNT_ERROR: {
                        TEXT: 'Create Account Error'
                    },
                    TERMS: {
                        TEXT: 'Terms of Service'
                    },
                    PRIVACY: {
                        TEXT: 'Privacy Policy'
                    }
                }
            },
            FORGOT_PASSWORD: {
                TEXT: 'Forgot Password',
                EVENT_ACTION: {
                    FORGOT_PASSWORD: {
                        TEXT: 'Forgot Password'
                    },
                    SEND_INSTRUCTIONS: {
                        TEXT: 'Send Instructions'
                    }
                }
            },
            PROFILE: {
                TEXT: 'Profile',
                EVENT_ACTION: {
                    BASIC_INFO: {
                        TEXT: 'Basic Info',
                        EVENT_LABEL: {
                            SAVE: {
                                TEXT: 'Save'
                            },
                            CANCEL: {
                                TEXT: 'Cancel'
                            }
                        }
                    },
                    ADDRESS: {
                        TEXT: 'Address',
                        EVENT_LABEL: {
                            ADD: {
                                TEXT: 'Add'
                            },
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            },
                            DELETE: {
                                TEXT: 'Delete'
                            }
                        }
                    },
                    UPDATE_PASSWORD: {
                        TEXT: 'UPDATE_PASSWORD',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            },
                            CANCEL: {
                                TEXT: 'Cancel'
                            }
                        }
                    }
                }
            },
            NAVIGATION: {
                TEXT: 'Navigation',
                EVENT_ACTION: {
                    SOCIAL_MEDIA: {
                        TEXT: 'Social Media',
                        EVENT_LABEL: {
                            FACEBOOK: {
                                TEXT: 'Facebook'
                            },
                            TWITTER: {
                                TEXT: 'Twitter'
                            }
                        }
                    },
                    BUY_GC: {
                        TEXT: 'Buy GC'
                    },
                    GC_CHECK_ADD: {
                        TEXT: 'GC Check Add'
                    },
                    MENU: {
                        TEXT: 'Menu'
                    }
                }
            },
            LANDING_PAGE: {
                TEXT: 'Landing Page',
                EVENT_ACTION: {
                    GO: {
                        TEXT: 'Go'
                    },
                    VERIFY_ADDRESS: {
                        TEXT: 'Verify Address',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    },
                    DINING_OPTION: {
                        TEXT: 'Dining Option'
                    },
                    DATE_TIME: {
                        TEXT: 'Date/Time'
                    }
                }
            },
            MENU_SELECTION: {
                TEXT: 'Menu Selection',
                EVENT_ACTION: {
                    MENU_GROUP: {
                        TEXT: 'Menu Group'
                    },
                    MENU_ITEM: {
                        TEXT: 'Menu Item'
                    },
                    MODIFIER_SELECTION: {
                        TEXT: 'Modifier Selection',
                        EVENT_LABEL: {
                            SELECT: {
                                TEXT: 'Select'
                            },
                            DESELECT: {
                                TEXT: 'Deselect'
                            }
                        }
                    },
                    MODIFIER_GROUP: {
                        TEXT: 'Modifier Group'
                    },
                    MENU_ITEM_QUANTITY: {
                        TEXT: 'Menu Item Quantity',
                        EVENT_LABEL: {
                            INCREMENT: {
                                TEXT: 'Increment'
                            },
                            DECREMENT: {
                                TEXT: 'Decrement'
                            }
                        }
                    }
                }
            },
            CART_EDIT: {
                TEXT: 'Cart Edit',
                EVENT_ACTION: {
                    ADD_ITEM: {
                        TEXT: 'Add Item',
                        EVENT_LABEL: {
                            ADD_ITEM: {
                                TEXT: 'Add Item'
                            },
                            REORDER: {
                                TEXT: 'Reorder'
                            }
                        }
                    },
                    REMOVE_ITEM: {
                        TEXT: 'Remove Item'
                    },
                    START_UPDATE_ITEM: {
                        TEXT: 'Start Update Item'
                    },
                    FINISH_UPDATE_ITEM: {
                        TEXT: 'Finish Update Item'
                    },
                    START_EDIT_DETAILS: {
                        TEXT: 'Start Edit Details',
                        EVENT_LABEL: {
                            DINING_OPTION_PREVIEW: {
                                TEXT: 'Dining Option Preview'
                            },
                            DATE_TIME_PREVIEW: {
                                TEXT: 'Date/Time Preview'
                            },
                            EDIT_DETAIL_BUTTON: {
                                TEXT: 'Edit Detail Button'
                            }
                        }
                    },
                    FINISH_EDIT_DETAILS: {
                        TEXT: 'Finish Edit Details'
                    }
                }
            },
            CHECKOUT: {
                TEXT: 'Checkout',
                EVENT_ACTION: {
                    CHECKOUT_VALID: {
                        TEXT: 'Checkout Valid'
                    },
                    CHECKOUT_CLICK: {
                        TEXT: 'Checkout Click'
                    },
                    ADDRESS_SUGGESTION: {
                        TEXT: 'Address Suggestion'
                    },
                    BACK_TO_MENU: {
                        TEXT: 'Back to Menu'
                    },
                    PLACE_ORDER: {
                        TEXT: 'Place Order',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    },
                    CHECKOUT: {
                        TEXT: 'Checkout'
                    },
                    ADDED_TIP: {
                        TEXT: 'Added Tip'
                    }
                }
            },
            AFTER_PLACE_ORDER_ERROR: {
                TEXT: 'After Place Order Error',
                EVENT_ACTION: {
                    OCCURRED: {
                        TEXT: 'Occurred'
                    },
                    RETRY: {
                        TEXT: 'Retry'
                    },
                    CANCEL: {
                        TEXT: 'Cancel'
                    }
                }
            },
            PROMO_CODE: {
                TEXT: 'Promo Code',
                EVENT_ACTION: {
                    APPLY: {
                        TEXT: 'Apply',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    },
                    REMOVE: {
                        TEXT: 'Remove',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    }
                }
            },
            LOYALTY_REWARDS: {
                TEXT: 'Loyalty Rewards',
                EVENT_ACTION: {
                    LOOKUP_REWARDS: {
                        TEXT: 'Lookup Rewards',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    },
                    REWARDS_AVAILABLE: {
                        TEXT: 'Rewards Available'
                    },
                    APPLY_REWARD: {
                        TEXT: 'Apply Reward',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    },
                    UNDO_REWARD: {
                        TEXT: 'Undo Reward - Checkout',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    },
                    REMOVE_REWARD: {
                        TEXT: 'Remove Reward - Menu',
                        EVENT_LABEL: {
                            SUCCESS: {
                                TEXT: 'Success'
                            },
                            ERROR: {
                                TEXT: 'Error'
                            }
                        }
                    }
                }
            }
        }
    })
    .constant('GTM_TRACKING_TAGS', {
        VIEW_MENU: 'ooViewMenu',
        CHECKOUT: 'ooCheckout',
        PLACE_ORDER: 'ooPlaceOrder'
    })
    .service('googleAnalyticsSetupService', GoogleAnalyticsSetupService)
    .service('googleAnalyticsTrackingService', GoogleAnalyticsTrackingService)
    .directive('googleAnalytics', GoogleAnalyticsDirective)
    .name;
